import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";
import { INSPECT_MAX_BYTES } from "buffer";

export default class Scenario4Part4 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 2;
	chapterIds = {
		
		scenario4_3a_s8: 'CALM - Scenario 4 - 3A - Segment 8',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part4.id;
	}

	public start() {
		const context = this;
		context.segment1Step1GoInformStaff();
	}
	
	
	private segment1Step1GoInformStaff() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_3a_s8, () => {
			this.segment3Step2EnterMoreReports();
		});
		context.scenario.updateObjective('Inform the staff of the Re-staffing changes');
	}

	private segment3Step2EnterMoreReports() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'In this scenario, a code response was followed to support the patient. It is not a patient incident. Therefore, no information is added to this report. This was added to the report: An in-patient was accidentally decannulated by a family member. Patient went into cardiac arrest and a Medical Emergency Code activated. Patient was resuscitated and transferred to ICU.'
				},
				{
					title: '24 Hour',
					description: 'This was added to the report: An in-patient was accidentally decannulated by a family member. Patient went into cardiac arrest and a Medical Emergency Code activated. Patient was resuscitated and transferred to ICU. Pharmacy and Supply notified of crash cart usage. Debrief conducted and report submitted to Nurse Manager.'
				},
				{
					title: 'End of Shift',
					description: 'This was added to the report: An in-patient was accidentally decannulated by a family member. Patient went into cardiac arrest and a Medical Emergency Code activated. Patient was resuscitated and transferred to ICU. Pharmacy and Supply notified of crash cart usage. Debrief conducted and report submitted to Nurse Manager.'
				}
			],
			review: {
				text:
					`
						<p class="regular-description-font" style="margin: 0;">
							Responding to a Medical Emergency Code is a unit-level responsibility; it is hectic and stressful. You are making split-second 
							decisions on how best to support the <span style="color: rgb(222, 225, 156)">Medical Emergency Code response</span>. <br /><br />
							Depending on your <span style="color: rgb(222, 225, 156)">local policy</span> or when you arrive at the Medical Emergency Code patient room, 
							a Charge Nurse may take the lead or other responsibilities to support the team effort. <span style="color: rgb(222, 225, 156)">Staffing 
							may need to be adjusted temporarily</span> if some staff members continue to support the code. <br /><br />
							Additionally, <span style="color: rgb(222, 225, 156)">the Charge Nurse may need to conduct, and document, a debrief</span> 
							to collect thoughts on what went right, what could be improved, and the issues and challenges that had to be overcome, but to also 
							regroup the staff back to their daily tasks.							
						</p>
						`
			},
			reflects: [
				{
					title: 'How is a Medical Emergency Code handled in your unit?',
					answer: ''
				},
				{
					title: 'What are the responsibilities for the Charge Nurse before, during, and after a Medical Emergency Code?',
					answer: ''
				},
				{
					title: 'Do you have a Medical Emergency Code Debrief form to complete?',
					answer: ''
				},
				{
					title: 'What would have happened if the patient had a current Allow Natural Death in place?',
					answer: ''
				},
				{
					title: 'What would have happened if the patient was in the isolation room?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			context.onDone();
		});
	}
}